<template>
	<div class="modal">
		<div class="row">
			<div class="col-md-12 end-sm end-md end-lg">
				<a @click="close()"><span class="fa-light fa-circle-xmark textXlg textGrey"></span></a>
			</div>
		</div>
		<div class="row margin-b40">
			<div class="col-md-12 w-full">
				<p class="textGrey textLg textCenter">LCR Destination</p>
			</div>
		</div>

		<div class="row margin-b30">
			<div class="w-full">
				<div class="card formPanel">
					<div class="content">
						<p class="textCenter margin-b20 mx-auto">{{ lcr.name }}</p>
						<div v-if="lcr.allowed_destinations?.length" class="mb-4 flex items-center justify-center">
							<div class="formGroup w-full md:w-1/3">
								<input id="search_box" v-model="searchEntry" type="text" placeholder="Search" />
							</div>
						</div>
						<div class="row">
							<div class="flex w-full flex-col gap-2">
								<div class="flex w-full flex-col justify-center">
									<p v-if="!lcr.allowed_destinations?.length" class="text-center font-semibold">
										This LCR has no allowed destinations
									</p>
									<p v-for="(dest, i) in filteredLCRs" v-else :key="i" class="py-1 text-center">
										{{ dest.zone_name }}
									</p>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>

		<div class="row margin-b20">
			<div class="col-md-12 mx-auto">
				<ul class="stepBtns">
					<li><a class="jmiBtn btnLg red" @click="close()">Close</a></li>
				</ul>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	inject: ['user', 'userRoles'],
	props: ['tenant', 'account', 'lcr'],

	data() {
		return {
			searchEntry: ''
		}
	},

	computed: {
		filteredLCRs() {
			let results = this.lcr.allowed_destinations
			if (this.searchEntry) {
				results = results.filter((z) => z.zone_name.toLowerCase().includes(this.searchEntry.toLowerCase()))
			}
			return results
		}
	},

	mounted() {
		document.addEventListener('keyup', this.onKeyUp)
	},
	beforeUnmount() {
		document.removeEventListener('keyup', this.onKeyUp)
	},

	methods: {
		close() {
			this.$emit('close')
		},
		onKeyUp(event) {
			if (event.key == 'Escape') this.$emit('close')
		}
	}
}
</script>
